import { createApp } from "vue";

import { router } from "./router";

import { i18n, loadDefaultLanguageAsync } from "@/setup/i18n-setup";
import Site from "@/views/Site.vue";

const app = createApp(Site);
app.use(router);
app.use(i18n);

loadDefaultLanguageAsync().then(() => {
    app.mount("#site-mount");
});

